import { render, staticRenderFns } from "./DeleteAccountBanner.vue?vue&type=template&id=78d3c601&scoped=true&"
import script from "./DeleteAccountBanner.vue?vue&type=script&lang=js&"
export * from "./DeleteAccountBanner.vue?vue&type=script&lang=js&"
import style0 from "./DeleteAccountBanner.vue?vue&type=style&index=0&id=78d3c601&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d3c601",
  null
  
)

export default component.exports